import React from 'react';
import styled from 'styled-components';

import { spaceM, spaceS } from '@xingternal/tokens';

import { Summary } from '@/contexts';

import { SummaryTag } from './components/summary-tag';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${spaceM} ${spaceS};
`;

export const FiltersSummary: React.VFC<Summary> = ({ keywords, location, radius, discipline }) => {
  const locationValue = (): string => `${location}${radius ? ` (${radius} km)` : ''}`;

  return (
    <Container>
      {keywords && <SummaryTag name="keywords" value={keywords} />}
      {location && <SummaryTag name="location" value={locationValue()} />}
      {discipline && <SummaryTag name="discipline" value={discipline.localizationValue} />}
    </Container>
  );
};
